import { ReactElement, useContext } from 'react';

import { Typography } from '@mui/material';
import { isFunction } from 'lodash';

import { useAppDispatch } from '../../../../store/hooks';
import { ModalContext } from '../../components/modal/ModalContext';
import ModalDialog from '../../components/modal/ModalDialog';
import { ModalContextModel } from '../../components/modal/models/modal-context.model';
import Button from '../../components/ui/Button/Button';
import {
  SetIsCheckedContext,
  SetIsCheckedContextModel,
} from '../../components/ui/Table/components/table/context/set-is-checked/set-is-checked.context';
import { UseDeleteModalProps } from './models/use-delete-modal-props.model';

export default function useDeleteModal<
  DeleteActionReturned,
  DeleteActionThunkArg,
  AfterDeleteActionReturned,
  AfterDeleteActionThunkArg,
  ResetTotalCountReturned = void,
  ResetTotalCountThunkArg = void
>({
  ids,
  deleteAction,
  param,
  afterDeleteAction,
  resetTotalCount,
  resetTotalCountParams,
}: UseDeleteModalProps<
  DeleteActionReturned,
  DeleteActionThunkArg,
  AfterDeleteActionReturned,
  AfterDeleteActionThunkArg,
  ResetTotalCountReturned,
  ResetTotalCountThunkArg
>): JSX.Element {
  const dispatch = useAppDispatch();
  const ctx = useContext(ModalContext) as ModalContextModel;
  const checkedCtx = useContext(
    SetIsCheckedContext
  ) as SetIsCheckedContextModel;

  const onClickHandler = () => {
    if (ids.length > 0) {
      Promise.all(
        ids.map((idArr: DeleteActionThunkArg) => dispatch(deleteAction(idArr)))
      ).then(() => {
        if (isFunction(afterDeleteAction)) {
          dispatch(afterDeleteAction(param));
          checkedCtx.setIsChecked({});
          if (resetTotalCount && resetTotalCountParams) {
            dispatch(resetTotalCount(resetTotalCountParams));
          }
        }
      });
    }

    ctx.modalStateHandler();
  };
  const buttons: ReactElement[] = [];
  buttons.push(
    <Button
      onClick={onClickHandler}
      key={'yesButton'}
      className="dialog-btn dialog-btn-yes"
    >
      <Typography className="dialog-btn-yes-text">Yes</Typography>
    </Button>
  );

  return (
    <ModalDialog
      content={<span>This will be deleted permanently.</span>}
      title={<span>Are you sure you want to delete this?</span>}
      extraButtons={buttons}
    />
  );
}
